<script>
export default {
  name: 'BaseFormChild',
  methods: {
    createElement() {
      return this.$createElement(...arguments)
    },
  },
  props: ['value', 'name', 'attrs', 'props', 'on', 'directives'],
  render(createElement) {
    const { value, name, props, attrs, on, $slots, directives } = this
    const self = this
    const children = Object.keys($slots)
      .map((key) => $slots[key])
      .filter((it) => it)
    return createElement(
      name,
      {
        ...self,
        props: {
          ...props, value,
        },
        directives,
        attrs,
        on: {
          ...on,
          input(v) {
            self.$emit('input', v)
            on && on.input && on.input(v)
          },
        },
      },
      // eslint-disable-next-line no-nested-ternary
      ['el-autocomplete', 'el-input', 'el-select'].includes(name) && props.slotRender ? name === 'el-select' ? [props.slotRender(self.createElement), children] : [props.slotRender(self.createElement)] : children,
    )
  },
}
</script>

<style>
</style>
